<template>
    <image-description-list
      title="nursing.nursingMedicalConcierge"
      titleColor="#603813"
      :starIconObj="{ componentName: 'shared', imgName: 'starIconPurple', imgFormat: 'svg' }"
      :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleLeft', imgFormat: 'svg', top: '0%' }"
      :starBackgroundRightObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleRight', imgFormat: 'svg', top: '-30%' }"
      :imageDescList="patientsStore.photoDescList"
      :labelColor="contentColor"
      class="pb-24"
    />
  </template>
  
  <script setup lang="ts">
  import { useNursingStore } from "@/stores/nursing";
  import { computed, onMounted, ref, toRefs } from "vue";
  import { useRouter } from "vue-router";
  import { useI18n } from "vue-i18n";
  
  const patientsStore = useNursingStore();
  const router = useRouter();
  const { t, locale } = useI18n();
  
  onMounted(async () => {});
  
  //not on home page, stop intro timer
  router.beforeEach(async (to, from) => {});
  
  const goTo = (refName) => {};
  
  const routeTo = (position) => {
    router.push({ name: position, params: { uid: "lczmx" } });
  };

  const props = defineProps({
    contentColor: {
        type: String,
        default: "#82488F"
    }
  });
  </script>